var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "81px",
    viewBox: "0 0 78 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "package") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825.000000, -3879.000000)",
    fillRule: "nonzero",
    id: "price"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.000000, 3692.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-10",
    transform: "translate(322.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(153.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5635553,72.2491163 L44.5260578,79.6069898 C42.5499075,80.1451171 40.4572771,80.1772723 38.4629969,79.6999878 L22.3178309,75.8303264 C21.6632321,75.721566 18.5346349,75.6222631 17.5286706,75.6222631 L13.5,75.6222631 L13.5,47.25 L27.9332618,47.25 C29.3804385,47.25 30.8019448,47.5021979 32.1576702,48.001865 L45.0105893,52.7368804 C48.5707725,54.0483095 50.5570306,57.6374008 49.8575084,61.2028485 L68.0803838,57.7036027 C72.1299117,56.9343991 76.1168676,59.528885 76.9752263,63.4852394 C77.8127277,67.3470197 75.4349938,71.1961901 71.5635553,72.2491163 Z",
    id: "Path",
    fill: "#FECEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5163906,72.0842231 L45.3214286,79.0714286 L45.3214286,53.0357143 C48.5428103,54.4876821 50.2934557,57.8371786 49.6268513,61.1664223 L68.003774,57.7078724 C72.0875347,56.9476146 76.1081944,59.5119268 76.9738092,63.4222693 C77.8183905,67.2391374 75.4205564,71.0435423 71.5163906,72.0842231 L71.5163906,72.0842231 Z",
    id: "Path",
    fill: "#FEB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9107143,0 L21.6964286,0 C20.3650714,0 19.2857143,1.05147707 19.2857143,2.34844491 L19.2857143,40.0801265 C19.2857143,41.3770944 20.3650714,42.4285714 21.6964286,42.4285714 L69.9107143,42.4285714 C71.2420714,42.4285714 72.3214286,41.3770944 72.3214286,40.0801265 L72.3214286,2.34844491 C72.3214286,1.05147707 71.2420714,0 69.9107143,0 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3571429,2.34844491 L71.3571429,40.0801265 C71.3571429,41.3764681 70.2967792,42.4285714 68.9902597,42.4285714 L45.3214286,42.4285714 L45.3214286,0 L68.9902597,0 C70.2967792,0 71.3571429,1.05210332 71.3571429,2.34844491 Z",
    id: "Path",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0334821,42.4290049 L2.390625,42.508868 C1.06714286,42.5197512 0,43.5914211 0,44.9094023 L0,78.5993057 C0,79.9251291 1.07935714,81 2.41071429,81 L12.0535714,81 C13.3849286,81 14.4642857,79.9251291 14.4642857,78.5993057 L14.4642857,44.8295392 C14.4642857,43.4742672 13.3349464,42.4038776 12.0334821,42.4290049 Z",
    id: "Path",
    fill: "#6C6CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2581681,17.5811247 L47.0260328,10.3489577 C46.0847302,9.40749029 44.5582675,9.40749029 43.6168042,10.3489577 L36.3846689,17.5811247 C35.4432056,18.5225921 35.4432056,20.0489008 36.3846689,20.9903682 C37.3259715,21.9318356 38.8524342,21.9318356 39.7938975,20.9903682 L42.9107871,17.8736257 L42.9107871,31.3392777 C42.9107871,32.6706393 43.9901431,33.75 45.3214989,33.75 C46.6528546,33.75 47.7322107,32.6706393 47.7322107,31.3392777 L47.7322107,17.8734649 L50.8491003,20.9902075 C51.7904029,21.9316749 53.3168656,21.9318356 54.2583289,20.9902075 C55.1996314,20.0489008 55.1996314,18.5224314 54.2581681,17.5811247 L54.2581681,17.5811247 Z",
    id: "Path",
    fill: "#FE9022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2591224,20.9908929 C53.3172974,21.9326786 51.7904481,21.9310714 50.8486232,20.9908929 L47.7322433,17.8730357 L47.7322433,31.3392857 C47.7322433,32.67 46.6521983,33.75 45.3214286,33.75 L45.3214286,9.64285714 C45.9385971,9.64285714 46.5557657,9.8775 47.0266782,10.3483929 L54.2591224,17.5805357 C55.1993402,18.5223214 55.1993402,20.0491071 54.2591224,20.9908929 Z",
    id: "Path",
    fill: "#FF641A"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice2);
export default __webpack_public_path__ + "static/media/price-2.747a8d1acf93a30ba88da632fc45e2ce.svg";
export { ForwardRef as ReactComponent };